import {GridDataHolderJsonArray, GridDataRowJson} from "back/commons/widgets/grid-libs";
import {Grid} from "back/commons/widgets/grid-tags";
import {EFolderState, GridColTreeDef, GridDataHolderJsonTree, GridDataRowJsonTree} from "back/commons/widgets/tree";
import {IInfo, IInfoBroker, IInfoConsumer} from "lib/commons/infos";
import {ILastDatasBuilder, JLastDatas} from "lib/commons/lastDatas";
import {IReg, IRegPointer, REG} from 'lib/commons/registry';
import {BaseAreaView, OBaseAreaViewInit} from "lib/commons/views";
import {JSX, ShadowJsx} from "lib/commons/xml/dom";
import {DOMSH} from "lib/commons/xml/domsh";
import {JSrcFields, JSrcFieldsTree, SRC, srcRef, srcUri} from "lib/wsp/src";
import {IWspUiEnv, JWspUriChangeMsg, WSP, Wsp} from "lib/wsp/wsp";
import {EGridDropPos, IGrid, IGridLineDrawer, IGridRowDropMgr} from "back/commons/widgets/grid-core";
import {InfoCurrentItem, InfoHighlighItemSgn, InfoReqCurrentItem, IShortDescCtx, IShortDescsTransfer, ITEM} from "lib/wsp/item";
import {IO} from "lib/commons/io/io";
import {IActionable, IContextMenuActionsPointer, IFocusActionables} from "back/commons/actionables";
import {AccelKeyMgr, Action, ACTION, ActionWrapper, EButtonUiContext, IAccelKeyMgrPointer, IAction} from "lib/commons/actions";
import {BASIS} from "back/commons/basis";
import {ActionBtn, Button} from "back/commons/widgets/buttons";
import {ShortDescCopy, SrcAction} from "back/wsp/actions/srcActions";
import {POPUP} from "back/commons/widgets/popups";
import {CellBuilderSrcIconCodeTitle, JSrcFieldsPointer} from "back/wsp/widgets/srcGridColumns";
import {ERROR} from "lib/core/errorReport";
import {EWspChangesEvts, WspsLivePlace} from "lib/wsp/wspsLive";


/**
 */
export interface Bookmarks extends BaseAreaView<IRegPointer<IWspUiEnv>> {
	initialize(init: OBookmarksInit): this
}

export interface OBookmarksInit extends OBaseAreaViewInit<IRegPointer<IWspUiEnv>> {

	defaultAction?: IAction<IBkCtx>;

	/** Actions pour le menuContextuel. */
	actions?: IAction<IBkCtx>[];

	accelKeyMgr?: AccelKeyMgr<IBkCtx>;

	/** Redéfinition de la colonne primaire. */
	primaryCol?: GridColTreeDef

	/** Colonnes secondaires à ajouter du grid. */
	secondaryCols?: GridColTreeDef[]

	/** Réagira aux infos issues de ce broker (item courant, highlight d'items selon signature) */
	itemHandlingReact?: IInfoBroker

	//lastDatas?: JLDBookmarks
}

export class Bookmarks extends BaseAreaView<IRegPointer<IWspUiEnv>> implements IInfoConsumer, ILastDatasBuilder, IGridLineDrawer, IBkCtx, IFocusActionables<IBkCtx>, IContextMenuActionsPointer<IBkCtx>, IAccelKeyMgrPointer<IBkCtx> {
	reg: IReg<IWspUiEnv>;
	wsp: Wsp;
	infoBroker: IInfoBroker;

	actions?: IAction<IBkCtx>[];
	accelKeyMgr?: AccelKeyMgr<IBkCtx>;

	/** boutons à afficher dans la focusToolbar. */
	focusActionables: IActionable<IBkCtx>[];

	get ctxMenuActions() {return {actions: this.actions, actionContext: this, rect: this.grid.getSelRect()}}

	/** Sélection en cours de src nodes dédoublonnés, sans les dossiers du bookmark. */
	shortDescs: JSrcFieldsTree[] = [];

	get emitter() {return this.grid} //on pointe le noeud focusable.
	get me() {return this} // IBkCtx

	lastError: undefined /* initing*/ | null /* pas d'erreur */ | 1;

	/** Arbre des données du bookmark. */
	tree = new BkGridDataTree();

	/** Date de dernière modif de l'arbre. */
	srcDt = -1;

	/* ShortDescs chargés correpondant aux entrées du boolmark. */
	srcMap: Map<srcRef, JSrcFields>;

	grid: Grid;

	protected _currentSrcUri: srcUri;
	protected _highlightSgn: RegExp;
	protected _assigned: srcRef;

	_dragging: boolean;

	/** Retourne le nb de lignes insérées*/
	async addBkNodes(parent: JBkNode | null, index: number, nodes: JBkNode[]) {
		nodes = nodes?.filter((n) => !isBkEntry(n) || !SRC.isNewSrcUri(n.refUri));
		if (!nodes || nodes.length === 0) return;
		const tmpSet = new Set<srcRef>();
		let countRows = 0;
		const buildMap = function (node: JBkNode) {
			if (isBkEntry(node)) {
				countRows++;
				tmpSet.add(node.refUri);
			} else if (isBkFolder(node)) {
				countRows++;
				node.ch.forEach(buildMap);
			}
		};
		nodes.forEach(buildMap);
		if (tmpSet.size > 0) {
			//Chargement de nouvelles srcs.
			const refs = await WSP.fetchShortDescs(this.wsp, this, ...tmpSet.keys());
			let i = 0;
			for (const srcRef of tmpSet) this.srcMap.set(srcRef, refs[i++]);
		}
		const offset = this.tree.getOffsetInChildren(parent, parent ? this.tree.getRowKeyChildren(parent) : this.tree.getDatas(), index);
		this.tree.updateDatasInTree(parent, index, 0, GridDataHolderJsonTree.defaultOpened, ...nodes.map(cloneBkNode));
		await this._saveBookmarks();
		this.grid.setSelectedRows([offset, -countRows - offset + 1]);
	}

	async deleteBkNodes(nodes: JBkNode[]): Promise<void> {
		const offset = this.grid.getActiveRow();
		for (const entry of nodes) this.tree.deleteRowKey(entry);
		this._gcSrcMaps();
		await this._saveBookmarks();
		if (offset >= 0) this.grid.setSelectedRows(Math.min(offset, this.tree.countRows() - 1));
	}

	async ensureRowVisible(srcUri: srcUri): Promise<boolean> {
		const rowKey = this.tree.findFirstRowKeyBySrcUri(srcUri);
		if (rowKey) this.grid.ensureRowVisible(this.tree.getOffset(rowKey));
		return rowKey != null;
	}


	protected _initialize(init: OBookmarksInit) {
		super._initialize(init); //init this.reg, this.area, this.areaContext
		this.wsp = this.reg.env.wsp;
		this.infoBroker = init.itemHandlingReact;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);

		const colDefs = [init.primaryCol || new GridColTreeDef('srcTree')
			.setSortable(false)
			.setFlex('1rem', 1, 1).setMinWidth('55px').setSortable(true)
			.setRowDropMgr(rowDropMgr)
			.setCellBuilder(new CellBuilderBk(this))];
		if (init.secondaryCols) colDefs.push(...init.secondaryCols);

		this.grid = sr.appendChild(new Grid().initialize({
			selType: 'multi',
			columnDefs: colDefs,
			dataHolder: this.tree,
			hideHeaders: true,
			autoSelOnFocus: 'first',
			lineDrawer: this.infoBroker ? this : null,
			skinOver: 'wsp-bookmarks/grid',
			skinScroll: 'scroll/small',
			emptyBody: (): Node => {
				if (this.lastError === undefined) {
					return <c-msg label="Chargement..." level="info"/>
				} else if (this.lastError === null) {
					return <c-msg label="Aucun favori" level="info"/>
				} else {
					return <c-msg label="Accès au serveur impossible" level="error"/>
				}
			},
			defaultAction: init.defaultAction,
			defaultActionCtx: this
		}));

		this.grid.addEventListener('grid-select', function (this: IGrid, ev: Event) {
			const bk = DOMSH.findHost(this) as Bookmarks;
			const sel = (this.dataHolder as GridDataHolderJsonArray<JBkNode>).getSelectedDatas();
			const set = new Set();
			for (const node of sel) {
				if (isBkEntry(node)) {
					const src = bk.srcMap.get(node.refUri);
					if (src) set.add(src);
				}
			}
			bk.shortDescs = Array.from(set);
			//console.log("bookmarks.shortDescs::::", bk.shortDescs);
			if (this.matches(':focus')) this.dispatchEvent(new CustomEvent<IFocusActionables<IShortDescCtx>>('c-focus-actions', {detail: bk, bubbles: true, composed: true}));
		});

		this.grid.addEventListener('focus', function (this: IGrid, ev: Event) {
			this.dispatchEvent(new CustomEvent<IFocusActionables<IShortDescCtx>>('c-focus-actions', {detail: DOMSH.findHost(this) as Bookmarks, bubbles: true, composed: true}));
		});

		this.grid.linesNode.setAttribute("draggable", "true");
		this.grid.linesNode.addEventListener('dragstart', function (ev: DragEvent) {
			//console.log(ev);
			const bk = DOMSH.findHost<Bookmarks>(DOMSH.findHost<IGrid>(this));
			const sel = bk.tree.getSelectedDatas();
			for (let i = 0, s = sel.length - 1; i < s; i++) {
				const ref = sel[i];
				for (let k = i + 1; k < sel.length; k++) {
					if (bk.tree.isRowKeyAncestor(ref, sel[k]) || bk.tree.isRowKeyAncestor(sel[k], ref)) {
						POPUP.showNotifInfo("Il est impossible de dupliquer ou déplacer une sélection contenant des éléments imbriqués.", this);
						ev.preventDefault();
						return;
					}
				}
			}
			bk._dragging = true;
			ITEM.setShortDescTransferToDragSession(bk, ev, 'build');
		});
		this.grid.linesNode.addEventListener('dragend', function (ev: DragEvent) {
			const bk = DOMSH.findHost<Bookmarks>(DOMSH.findHost<IGrid>(this));
			bk._dragging = false;
			ITEM.resetShortDescTransferToDragSession();
		});

		if (init.accelKeyMgr) {
			this.accelKeyMgr = init.accelKeyMgr;
			this.grid.addEventListener('keydown', (ev: KeyboardEvent) => {
				this.accelKeyMgr.handleKeyboardEvent(ev, this);
			});
		}

		let actions = init.actions;
		if (!actions && this.hasAttribute("actions")) actions = this.reg.mergeLists(...BASIS.extractAttr(this, 'actions').split(' '));
		if (actions) {
			actions = this.overrideActions(actions);
			this.actions = actions;
			this.focusActionables = ActionBtn.buildButtons(actions, this, 'bar');
		}
	}

	protected overrideActions(actions: IAction<IBkCtx>[]) {
		//On force des libellés plus précis des actions d'édition sur les items pour éviter une confusion avec des actions sur les favoris.
		let idx = actions.findIndex((a) => a.getId() === "delSrc");
		if (idx >= 0) actions[idx] = new ActionWrapper().setOverridenSvc(actions[idx]).setLabel("Supprimer de l'atelier");
		idx = actions.findIndex((a) => a.getId() === "renameSrc");
		if (idx >= 0) actions[idx] = new ActionWrapper().setOverridenSvc(actions[idx]).setLabel("Renommer dans l'atelier");
		return ACTION.injectSepByGroup(actions, this.reg.getPref("groupOrder.wsp.shortDesc", ""), this);
	}

	async _fetchBookmarks() {
		try {
			if (!this.wsp.isAvailable) await this.wsp.waitForAvailable(this);
			const resp = await this.wsp.wspServer.config.privateFolderUrl.fetch(IO.qs("cdaction", "GetSrc", "format", "stream", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", "/~bookmark.js"), 'json');
			if (resp.status === 200) {
				this.srcDt = (JSON.parse(resp.headers.get("X-SCFIELDS")) as JSrcFields).srcDt;
				const bkRoot = resp.asJson;
				//console.log("boolmarks::::::::", this.srcDt, bkRoot);
				const srcRefMap = new Map<srcRef, JSrcFields>();
				const buildMap = function (node: JBkNode) {
					if (isBkEntry(node)) {
						srcRefMap.set(node.refUri, null);
					} else if (isBkFolder(node)) {
						node.ch.forEach(buildMap);
					}
				};
				bkRoot.ch.forEach(buildMap);
				if (srcRefMap.size > 0) {
					const refs = await WSP.fetchShortDescs(this.wsp, this, ...srcRefMap.keys());
					let i = 0;
					for (const srcRef of srcRefMap.keys()) srcRefMap.set(srcRef, refs[i++]);
				}
				const normalizeRef = function (node: JBkNode) {
					if (isBkEntry(node)) {
						const srcRefIdent = srcRefMap.get(node.refUri);
						if (srcRefIdent) {
							const srcRef = SRC.srcRef(srcRefIdent);
							if (node.refUri !== srcRef) {
								//La ref a changée (alias d'id).
								srcRefMap.set(srcRef, srcRefMap.get(node.refUri));
								// srcRefMap.delete(node.refUri); NON : tjs utile si la ref est encore présente ailleurs dans les bookmarks
								node.refUri = srcRef;
							}
						}
					} else if (isBkFolder(node)) {
						node.ch.forEach(normalizeRef);
					}
				};
				bkRoot.ch.forEach(normalizeRef);

				this.srcMap = srcRefMap;
				this.lastError = null;
				this.tree.setDatas(bkRoot.ch);
				if (this.infoBroker) {
					const req = new InfoReqCurrentItem();
					this.infoBroker.dispatchInfo(req, this);
					if (req.srcUri) this._setCurrentItem(req.srcUri);
				}
			} else {
				this.srcMap = new Map();
				this.srcDt = -1;
				this.lastError = resp.status === 404 ? null : 1;
				this.tree.setDatas([]);
			}
		} catch (e) {
			ERROR.log(e);
			this.srcDt = -1;
			this.lastError = 1;
			this.tree.setDatas([]);
		}
	}

	async _saveBookmarks(): Promise<void> {
		try {
			const fields = await this.wsp.wspServer.config.privateFolderUrl.fetchJson<JSrcFields>(IO.qs("cdaction", "PutSrc", "format", "JSON", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", "/~bookmark.js"), {
				method: "POST",
				body: JSON.stringify({bookmarkVersion: "1.0", ch: this.tree.getDatas().map(exportBkNode)}),
				headers: {"Content-Type": "application/json"}
			});
			this.srcDt = fields.srcDt;
			this.reg.env.universe.wsFrames.ws.postMsg({svc: 'liaise', type: "bookmarks.saved"})
		} catch (e) {
			ERROR.report("Les modifications de vos favoris n'ont pas pu être enregistrées.", e);
			this._fetchBookmarks();
		}
	}

	_gcSrcMaps() {
		if (!this.srcMap) return;
		const set = new Set<srcRef>(this.srcMap.keys());
		const clearSet = function (node: JBkNode) {
			if (isBkEntry(node)) {
				set.delete(node.refUri);
			} else if (isBkFolder(node)) {
				node.ch.forEach(clearSet);
			}
		};
		this.tree.getDatas().forEach(clearSet);
		for (const srcRef of set) this.srcMap.delete(srcRef);
	}

	/** Identifie l'item courant dans l'app. */
	_setCurrentItem(srcUri: srcUri | null) {
		this._currentSrcUri = srcUri;
		this.grid.invalidateRows();
		if (this._currentSrcUri) this.ensureRowVisible(this._currentSrcUri);
	}

	redrawLine(row: GridDataRowJsonTree<JBkNode>, line: HTMLElement) {
		if (!isBkEntry(row.rowDatas)) return;
		const shortDesc: JSrcFields | null = this.srcMap.get(row.rowDatas.refUri);
		line.classList.toggle('current', shortDesc?.srcUri === this._currentSrcUri);
		if (this._highlightSgn) {
			if (this._assigned && (this._assigned === shortDesc?.srcId || this._assigned === shortDesc?.srcUri)) {
				line.classList.toggle('assigned', true);
				line.classList.toggle('highlight', false);
			} else {
				const sgn = shortDesc?.itSgn;
				line.classList.toggle('highlight', sgn ? this._highlightSgn.test(sgn) : false);
				line.classList.toggle('assigned', false);
			}
		} else {
			line.classList.toggle('highlight', false);
			line.classList.toggle('assigned', false);
		}
	}

	buildLastDatas?(parentLastDatas: JLastDatas): void {
		// let lastDatasKey = this.getAttribute('last-datas');
		// if (lastDatasKey) {
		//
		// }
	}

	onInfo(info: IInfo): void {
		if (info instanceof InfoCurrentItem) {
			if (this.hidden) return;
			this._setCurrentItem(info.srcUri);
		} else if (info instanceof InfoHighlighItemSgn) {
			this._highlightSgn = info.sgnPattern;
			this._assigned = info.assigned;
			if (this.hidden) return;
			this.grid.invalidateRows();
		}
	}

	onViewHidden(closed?: boolean): void {
		if (this.infoBroker) this.infoBroker.removeConsumer(this);
		if (closed) {
			this.reg.env.universe.wsFrames.ws.msgListeners.removeListener('liaise', this._onLiaiseMsg);
			this.reg.env.place.eventsMgr.removeListener("onConnectionRenewed", this._onConnRenewed);
			this.reg.env.place.eventsMgr.removeListener('wspUriChange', this._onWspUriChange);
		}
	}

	onViewShown() {
		if (!this._onLiaiseMsg) {
			this._onLiaiseMsg = this.onLiaiseMsg.bind(this);
			this.reg.env.universe.wsFrames.ws.msgListeners.on('liaise', this._onLiaiseMsg);
			this._onConnRenewed = this.onConnRenewed.bind(this);
			this.reg.env.place.eventsMgr.on("onConnectionRenewed", this._onConnRenewed);
			this._onWspUriChange = this.onWspUriChange.bind(this);
			this.reg.env.place.eventsMgr.on('wspUriChange', this._onWspUriChange);
		}
		if (this.infoBroker) this.infoBroker.addConsumer(this);
		if (this.srcMap == null) this._fetchBookmarks();
		else if (this.infoBroker) {
			const req = new InfoReqCurrentItem();
			this.infoBroker.dispatchInfo(req, this);
			this._setCurrentItem(req.srcUri); //permet aussi le refresh de _currentHighlightSgn
		}
	}

	/** Doit être appelé dès qu'on détecte qu'on a perdu la sync avec le server. */
	protected onSyncLost() {
		if (this.hidden) {
			if (this.srcMap) {
				this.tree.setDatas([]);
				this.srcMap = null;
			}
		} else {
			this._fetchBookmarks();
		}
	}

	/** Mémoire du listener des WspChanges pour delete. */
	protected _onWspUriChange: (msg: JWspUriChangeMsg, from: WspsLivePlace | 'local' | 'server') => void;

	onWspUriChange(msg: JWspUriChangeMsg, from: WspsLivePlace | 'house' | 'server') {
		if (!this.srcMap) return;
		if (msg.type === EWspChangesEvts.u || msg.type === EWspChangesEvts.r) {
			if (this.srcMap.has(SRC.srcRef(msg))) {
				this.wsp.fetchShortDesc(SRC.srcRef(msg)).then((sd) => {
					const shortDesc = this.srcMap.get(SRC.srcRef(sd));
					if (shortDesc) {
						for (const k in shortDesc) (shortDesc as any)[k] = undefined;
						Object.assign(shortDesc, sd);
						this.grid.invalidateRows();
					}
				})
			}
		} else if (msg.type === EWspChangesEvts.s) {
			const shortDesc = this.srcMap.get(SRC.srcRef(msg));
			if (shortDesc) {
				shortDesc['itSt'] = msg.itSt;
				this.grid.invalidateRows();
			}
		}
	}

	/** Détection d'une écriture concurente via le service de liaise. */
	protected _onLiaiseMsg: (m: Jsonisable) => void;

	protected onLiaiseMsg(m: Jsonisable) {
		if (m.type === 'bookmarks.saved') this.onSyncLost();
	}

	protected _onConnRenewed: () => void;

	protected async onConnRenewed() {
		const resp = await this.wsp.wspServer.config.privateFolderUrl.fetch(IO.qs("cdaction", "GetSrc", "format", "JSON", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", "/~bookmark.js"), 'json');
		if (resp.status === 200 ? this.srcDt !== resp.asJson.srcDt : resp.status === 404 && this.srcDt !== -1) this.onSyncLost();
	}
}

function exportBkNode(node: JBkNode): JBkNode {
	if (isBkEntry(node)) {
		return {refUri: node.refUri};
	} else {
		const r = {label: node.label} as JBkFolder;
		if (node.ch) r.ch = node.ch.map(exportBkNode)
		return r;
	}
}

REG.reg.registerSkin("wsp-bookmarks", 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	[hidden] {
		display: none !important;
	}

	c-grid {
		flex: 1;
		border: none;
	}
`);

REG.reg.registerSkin('wsp-bookmarks/grid', 1, /* language=CSS */ `
	.highlight {
		background-color: var(--row-highlight-bgcolor);
	}

	.assigned {
		background-color: var(--row-assigned-bgcolor);
	}

	.current {
		background-position: right;
		background-repeat: no-repeat;
		background-image: var(--row-current-img-end);
		background-color: var(--row-current-bgcolor);
	}
`);

customElements.define("wsp-bookmarks", Bookmarks);


/** Contexte pour les actions du bookmark. */
export interface IBkCtx extends IShortDescCtx {
	me?: Bookmarks
}

/** Schéma Json du bookmark : Objet racine. */
interface JBkRoot {
	bookmarkVersion: string
	ch: JBkNode[]
}

/** Schéma Json du bookmark : Dossier. */
interface JBkFolder {
	label?: string
	ch?: JBkNode[]
}

function isBkFolder(d: JBkNode): d is JBkFolder {return d && ('label' in d)}

/** Schéma Json du bookmark : noeud source de l'atelier. */
interface JBkEntry {
	/** ref dans le fichier des bookmarks. */
	refUri?: srcRef
}

function isBkEntry(d: JBkNode): d is JBkEntry {return d && ('refUri' in d)}


type JBkNode = JBkFolder | JBkEntry;


function cloneBkNode(node: JBkNode): JBkNode {
	if (isBkEntry(node)) return {refUri: node.refUri};
	else if (isBkFolder(node)) return {label: node.label, ch: node.ch.map(cloneBkNode)};
	return null;
}

/** Extension de IShortDescsTransfer qui ajoute les données propres au bookmark dans le presse-papoer. */
interface IBookmarksTransfer extends IShortDescsTransfer {
	bookmarks?: JBkNode[]
}


class BkGridDataTree extends GridDataHolderJsonTree<JBkNode> {

	constructor() {
		super('ch');
		this.setOpenAll(true);
	}

	findFirstRowKeyBySrcUri(srcUri: srcUri): JBkEntry {
		let result: JBkEntry;
		const match = function (data: JBkNode) {
			if ((data as JBkEntry).refUri === srcUri) {
				result = data as JBkEntry;
			} else if ((data as JBkFolder).ch) {
				(data as JBkFolder).ch.find(match);
			}
			return result != null;
		};
		this.getDatas().find(match);
		return result;
	}
}

export class CellBuilderBk extends CellBuilderSrcIconCodeTitle {

	constructor(public bk: Bookmarks) {
		super(bk.reg, bk.wsp.wspMetaUi, false, bk.wsp.srcUriItemsSortFn);
	}

	redrawCell(row: GridDataRowJson<any>, root: HTMLElement): void {
		super.redrawCell(row, root);
		(root as JSrcFieldsPointer)._srcFields = row.cacheHolder.shortDesc;
	}

	protected _getValue(row: GridDataRowJsonTree<any>): string {
		return row.cacheHolder.code || this._buildCache(row).code;
	}

	protected _getIcon(row: GridDataRowJsonTree<any>): string {
		return this._buildCache(row).icon;
	}

	protected _getTitle(row: GridDataRowJsonTree<any>): string {
		const sd = row.cacheHolder.shortDesc;
		return sd ? sd.itTi || "" : "";
	}

	protected _buildCache(row: GridDataRowJsonTree<JBkNode>): any {
		const cache = row.cacheHolder;
		if (isBkEntry(row.rowDatas)) {
			const shortDesc = this.bk.srcMap.get(row.rowDatas.refUri);
			if (shortDesc) {
				cache.code = this.srcRdr.getMainName(shortDesc, this.wspMetaUi);
				cache.icon = this.srcRdr.getIcon(shortDesc, this.wspMetaUi);
				cache.shortDesc = shortDesc;
				return cache;
			}
		} else if (isBkFolder(row.rowDatas)) {
			cache.code = row.rowDatas.label;
			cache.icon = row.getFolderState() === EFolderState.opened ? "/@skin@/wsp/views/bookmarks/folder-open.svg" : "/@skin@/wsp/views/bookmarks/folder.svg";
			cache.shortDesc = null;
			return cache;
		}
		cache.code = " ";
		cache.icon = "/@skin@/wsp/itemType/icons/itemNotFound/icovalid.png";
		cache.shortDesc = null;
		return cache;
	}

}

function onKeypressPrompt(ev: KeyboardEvent) {
	if (ev.key === 'Enter') {
		POPUP.findPopupableParent(ev.target as Element).close((ev.currentTarget as HTMLElement).shadowRoot.querySelector('input').value);
		ev.preventDefault();
		ev.stopImmediatePropagation();
	}
}

function onClickPromptDone(this: Button) {
	POPUP.findPopupableParent(this).close(DOMSH.findDocumentOrShadowRoot(this).querySelector('input').value);
	POPUP.findPopupableParent(this).close(DOMSH.findDocumentOrShadowRoot(this).querySelector('input').value);
}

function onClickPromptCancel(this: Button) {POPUP.findPopupableParent(this).close(null)}

export class BkCreateFolder extends Action<IBkCtx> {
	_id = "createFolder";
	_label = "Nouveau dossier...";
	_group = "localEdit";

	async execute(ctx: IBkCtx, ev?: Event) {
		const r = await POPUP.showDialog<string | null>(<c-box skin="wsp-bookmarks/promptFolder" skinOver="webzone:panel form-control-areas" onkeypress={onKeypressPrompt}>
			<ShadowJsx>
				<label>
					<div>Nom du dossier</div>
					<input/>
				</label>
				<footer>
					<c-button label="Créer" class="default" ui-context="dialog" onclick={onClickPromptDone}/>
					<c-button label="Annuler" ui-context="dialog" onclick={onClickPromptCancel}/>
				</footer>
			</ShadowJsx>
		</c-box>, ctx.me, {titleBar: {barLabel: {label: "Nouveau dossier des favoris"}}, resizer: {}}).onNextClose();
		if (r) {
			const tree = ctx.me.tree;
			const newNodes = [{label: r, ch: ([] as JBkNode[])} as JBkFolder];
			const d = tree.getDataByOffset(ctx.me.grid.getActiveRow());
			if (!d) {
				ctx.me.addBkNodes(null, tree.getDatas().length, newNodes);
			} else {
				ctx.me.addBkNodes(tree.getRowKeyParent(d), tree.getRowKeyIndex(d), newNodes);
			}
		}
	}
}

export class BkRenameFolder extends Action<IBkCtx> {
	_id = "renameFolder";
	_label = "Renommer...";
	_group = "localEdit";

	isEnabled(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() != 1) return false;
		return super.isEnabled(ctx);
	}

	isVisible(ctx: IBkCtx): boolean {
		if (!super.isVisible(ctx)) return false;
		return isBkFolder(ctx.me.tree.getDataByOffset(ctx.me.grid.getActiveRow()));
	}

	async execute(ctx: IBkCtx, ev?: Event) {
		const d = ctx.me.tree.getDataByOffset(ctx.me.grid.getActiveRow());
		if (!isBkFolder(d)) return;
		const r = await POPUP.showDialog<string | null>(<c-box skin="wsp-bookmarks/promptFolder" skinOver="webzone:panel form-control-areas" onkeypress={onKeypressPrompt}>
			<ShadowJsx>
				<label>
					<div>Nom du dossier</div>
					<input value={d.label}/></label>
				<footer>
					<c-button label="Renommer" class="default" ui-context="dialog" onclick={onClickPromptDone}/>
					<c-button label="Annuler" ui-context="dialog" onclick={onClickPromptCancel}/>
				</footer>
			</ShadowJsx>
		</c-box>, ctx.me, {titleBar: {barLabel: {label: "Renommer le dossier des favoris"}}, resizer: {}}).onNextClose();
		if (r) {
			d.label = r;
			ctx.me.grid.invalidateRows();
			return ctx.me._saveBookmarks();
		}
	}
}

REG.reg.registerSkin('wsp-bookmarks/promptFolder', 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	:focus-visible {
		outline: var(--focus-outline);
	}

	label {
		flex: 1;
		margin: 1em;
		padding: .5em;
	}

	input {
		flex: 1;
		display: flex;
		margin: .5em;
		width: 100%;
		font-size: inherit;
	}

	footer {
		display: flex;
		justify-content: flex-end;
		border-top: 1px solid var(--border-color);
	}
`);


export class BkDel extends SrcAction<IBkCtx> {
	_id = "del";
	_label = "Éliminer des favoris";
	_group = "localEdit";
	isNotRemoved = false;

	isEnabled(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() === 0) return false;
		return super.isEnabled(ctx);
	}

	execute(ctx: IBkCtx, ev?: Event): any | "noPreventDefault" {
		ctx.me.deleteBkNodes(ctx.me.tree.getSelectedDatas());
	}
}

/** Copie dans le presse-papier avec ajout des données brutes du bookmark. */
export class BkCopy extends ShortDescCopy {

	constructor() {
		super();
		this.atLeastOne = false;
		this.isNotRemoved = false;
	}

	isEnabled(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() === 0) return false;
		return super.isEnabled(ctx);
	}

	execute(ctx: IBkCtx, ev?: Event): Promise<void> {
		return ITEM.setShortDescTransferToClipboard(ctx, {bookmarks: ctx.me.tree.getSelectedDatas().map(cloneBkNode)} as IBookmarksTransfer);
	}
}

export class BkCut extends SrcAction<IBkCtx> {
	_id = "cut";
	_label = "Couper";
	_group = "clipboard";
	isNotRemoved = false;

	isEnabled(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() === 0) return false;
		return super.isEnabled(ctx);
	}

	execute(ctx: IBkCtx, ev?: Event): any | "noPreventDefault" {
		const sel = ctx.me.tree.getSelectedDatas();
		ctx.me.deleteBkNodes(sel);
		ITEM.setShortDescTransferToClipboard(ctx, {bookmarks: sel.map(cloneBkNode)} as IBookmarksTransfer);
	}
}

export class BkPasteBefore extends SrcAction<IBkCtx> {
	_id = "pasteBefore";
	_label = "Coller avant";
	_group = "clipboard";
	isNotRemoved = false;

	isVisible(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() !== 1) return false;
		//Action active que si l'entrée sel est folder
		if (!isBkFolder(ctx.me.tree.getDataByOffset(ctx.me.grid.getActiveRow()))) return false;
		return super.isVisible(ctx);
	}

	protected isVisibleSuper(ctx: IBkCtx): boolean {
		return super.isVisible(ctx);
	}

	isEnabled(ctx: IBkCtx): boolean {
		//Eval async, true par défaut.
		return true;
	}

	/** On bloque dans les barres d'outils (pb clipboard asynchrone). */
	buildCustomButton(ctx: IBkCtx, uiContext: EButtonUiContext, parent?: Element): Element | null | undefined {return uiContext === 'bar' ? null : undefined}

	async initButtonNode(buttonNode: Element, ctx: IBkCtx) {
		if (buttonNode instanceof ActionBtn) {
			if (!BkPasteBefore.pendingBtns) BkPasteBefore.pendingBtns = [buttonNode];
			else BkPasteBefore.pendingBtns.push(buttonNode);
			if (!BkPasteBefore.pending) {
				BkPasteBefore.pending = ITEM.getShortDescsTransferFromClipboard(ctx.reg.env.wsp, ctx.emitter);
				try {
					const srcs = await BkPasteBefore.pending;
					//console.log("getShortDescTransferFromClipboard::::::", srcs);
					if (srcs === false) {
						POPUP.showNotifWarning("L'accès au presse-papier n'est pas autorisé par votre navigateur. Modifiez les paramètres du site pour rendre opérationnelles les fonctions de copier/coller.", buttonNode);
					} else if (BkPasteBefore.pendingBtns) for (const btn of BkPasteBefore.pendingBtns) {
						(btn.action as BkPasteBefore).updateButton(btn, srcs);
					}
				} finally {
					BkPasteBefore.pendingBtns = null;
					BkPasteBefore.pending = null;
				}
			}
		}
	}

	updateButton(btn: ActionBtn<IBkCtx>, transfer: IBookmarksTransfer | ClipboardItem[]) {
		if (transfer && !Array.isArray(transfer)) {
			if (transfer.bookmarks && transfer.bookmarks.length > 0) return;
			if (transfer.srcRefs && transfer.srcRefs.length > 0) return;
		}
		btn.disabled = true;
	}

	async execute(ctx: IBkCtx, ev?: Event) {
		const transfer = await ITEM.getShortDescsTransferFromClipboard(ctx.reg.env.wsp, ctx.emitter) as IBookmarksTransfer;
		if (!transfer || Array.isArray(transfer)) return;
		const tree = ctx.me.tree;
		const from = tree.getDataByOffset(ctx.me.grid.getActiveRow());
		const parent = tree.getRowKeyParent(from);
		const index = tree.getRowKeyIndex(from);
		if (transfer.bookmarks) {
			return ctx.me.addBkNodes(parent, index, transfer.bookmarks);
		} else if (transfer.srcRefs) {
			return ctx.me.addBkNodes(parent, index, transfer.srcRefs.map(srcRef => {return {refUri: srcRef}}));
		}
	}

	static pending: Promise<IShortDescsTransfer | false | null | ClipboardItem[]>;
	static pendingBtns: ActionBtn<IBkCtx>[];
}

export class BkPasteInOrBefore extends BkPasteBefore {
	_id = "pasteIn";
	_label = "Coller dans";

	getLabel(ctx: IBkCtx): string {
		const offset = ctx.me.grid.getActiveRow();
		if (offset === -1) return "Coller"; //racine du bookmark.
		return isBkFolder(ctx.me.tree.getDataByOffset(offset)) ? "Coller dans" : "Coller avant";
	}

	isVisible(ctx: IBkCtx): boolean {
		const count = ctx.me.grid.countSelectedRows();
		if (count === 0) return true; //racine du bookmark.
		if (count !== 1) return false;
		return super.isVisibleSuper(ctx);
	}

	async execute(ctx: IBkCtx, ev?: Event) {
		const transfer = await ITEM.getShortDescsTransferFromClipboard(ctx.reg.env.wsp, ctx.emitter) as IBookmarksTransfer;
		if (!transfer || Array.isArray(transfer)) return;
		const tree = ctx.me.tree;
		const from = tree.getDataByOffset(ctx.me.grid.getActiveRow());
		let parent = from;
		let index: number;
		if (!from || isBkFolder(from)) {
			index = (from ? tree.getRowKeyChildren(from) : tree.getDatas()).length;
		} else {
			parent = tree.getRowKeyParent(from);
			index = tree.getRowKeyIndex(from);
		}
		if (transfer.bookmarks) {
			return ctx.me.addBkNodes(parent, index, transfer.bookmarks);
		} else if (transfer.srcRefs) {
			return ctx.me.addBkNodes(parent, index, transfer.srcRefs.map(srcRef => {return {refUri: srcRef}}));
		}
	}
}

export class BkPasteAfter extends BkPasteBefore {
	_id = "pasteAfter";
	_label = "Coller après";


	isVisible(ctx: IBkCtx): boolean {
		if (ctx.me.grid.countSelectedRows() !== 1) return false;
		return super.isVisibleSuper(ctx);
	}

	async execute(ctx: IBkCtx, ev?: Event) {
		const transfer = await ITEM.getShortDescsTransferFromClipboard(ctx.reg.env.wsp, ctx.emitter) as IBookmarksTransfer;
		if (!transfer || Array.isArray(transfer)) return;
		const tree = ctx.me.tree;
		const from = tree.getDataByOffset(ctx.me.grid.getActiveRow());
		const parent = tree.getRowKeyParent(from);
		const index = tree.getRowKeyIndex(from) + 1;
		if (transfer.bookmarks) {
			return ctx.me.addBkNodes(parent, index, transfer.bookmarks);
		} else if (transfer.srcRefs) {
			return ctx.me.addBkNodes(parent, index, transfer.srcRefs.map(srcRef => {return {refUri: srcRef}}));
		}
	}
}


/** Gestion du drop dans l'arbre. */
const rowDropMgr = {
	onDragOverRow(ev: DragEvent, grid: IGrid, row: GridDataRowJsonTree<JBkNode>, line: HTMLElement): EGridDropPos | EGridDropPos {
		ev.dataTransfer.dropEffect = 'none';
		const bk = DOMSH.findHost<Bookmarks>(grid);
		const tree = bk.tree;
		if (bk._dragging) {
			//Drag interne au bookmark
			let pos = !row ? EGridDropPos.after : EGridDropPos.before | EGridDropPos.after;
			if (!ev.shiftKey) {
				//Déplacement, on élimine les possibilités qui ne constitueraient pas un déplacement effectif ou sui sont impossibles.
				if (row) {
					const offset = tree.getOffset(row.rowKey);
					if (grid.isRowSelected(offset)) return EGridDropPos.none;
					const sel = bk.tree.getSelectedDatas();
					//Déplacement impossible si la cible est dans descendance d'un source.
					if (sel.find((node) => bk.tree.isRowKeyAncestor(node, row.rowKey))) return EGridDropPos.none;
					//pas de déplacement si la cible du drop est le dossier parent d'au moins une source à déplacer
					if (isBkFolder(row.rowDatas) && sel.find(d => tree.getRowKeyParent(d) === row.rowKey)) return EGridDropPos.none;
					//pas de déplacement si la cible est voisine d'un source sélectionnée à déplacer
					const parent = tree.getRowKeyParent(row.rowKey);
					if (offset > 0 && grid.isRowSelected(offset - 1)) {
						if (tree.getRowKeyParent(tree.getRowKey(offset - 1)) === parent) pos &= ~EGridDropPos.before;
					}
					if (grid.isRowSelected(offset + 1)) {
						if (tree.getRowKeyParent(tree.getRowKey(offset + 1)) === parent) pos &= ~EGridDropPos.after;
					}
					if (pos === EGridDropPos.none) return pos;
				} else {
					//dragOver en zone blanche, pas de déplacement si la dernière ligne est sel et de depth 0.
					const last = tree.countRows() - 1;
					if (tree.getRowKeyParent(tree.getRowKey(last)) == null && grid.isRowSelected(last)) return EGridDropPos.none;
				}
			}
			ev.dataTransfer.dropEffect = ev.shiftKey ? 'copy' : 'move';
			return row && isBkFolder(row.rowDatas) ? pos | EGridDropPos.over : pos;
		} else {
			//Drag externe au bookmark
			const transfer = ITEM.getShortDescsTransferFromDragSession(bk.reg, ev.dataTransfer, {targetSrcType: "itemOrSpace"}, grid);
			if (transfer && transfer.wspCd === bk.wsp.code && transfer.srcRefs && transfer.srcRefs.length > 0) {
				ev.dataTransfer.dropEffect = 'copy';
				if (!row) return EGridDropPos.after;
				if (isBkFolder(row.rowDatas)) return EGridDropPos.before | EGridDropPos.after | EGridDropPos.over;
				return EGridDropPos.before | EGridDropPos.after;
			}
		}
		return EGridDropPos.none;
	},

	dropOnRow(ev: DragEvent, grid: IGrid, row: GridDataRowJson<JBkNode>, line: HTMLElement, pos: EGridDropPos): void {
		const bk = DOMSH.findHost<Bookmarks>(grid);
		if (bk._dragging) {
			const sel = bk.tree.getSelectedDatas();
			if (!ev.shiftKey) {
				//On supprime les sources
				for (const entry of sel) bk.tree.deleteRowKey(entry);
			}
			//On insère à l'emplacement
			//const offset = bk.tree.getOffset(row.rowKey);
			//bk.grid.setActiveRow(offset);
			const nodes = sel.map(cloneBkNode);
			if (!row) {
				bk.addBkNodes(null, bk.tree.getDatas().length, nodes);
			} else if (pos === EGridDropPos.over) {
				bk.addBkNodes(row.rowDatas, bk.tree.getRowKeyChildren(row.rowKey).length, nodes);
			} else if (pos === EGridDropPos.before) {
				bk.addBkNodes(bk.tree.getRowKeyParent(row.rowKey), bk.tree.getRowKeyIndex(row.rowKey), nodes);
			} else {
				bk.addBkNodes(bk.tree.getRowKeyParent(row.rowKey), bk.tree.getRowKeyIndex(row.rowKey) + 1, nodes);
			}
		} else {
			const transfer = ITEM.getShortDescsTransferFromDragSession(bk.reg, ev.dataTransfer, {targetSrcType: "itemOrSpace"}, grid);
			if (transfer && transfer.wspCd === bk.wsp.code && transfer.srcRefs && transfer.srcRefs.length > 0) {
				const nodes = transfer.srcRefs.map(srcRef => {return {refUri: srcRef}});
				if (!row) {
					bk.addBkNodes(null, bk.tree.getDatas().length, nodes);
				} else if (pos === EGridDropPos.over) {
					bk.addBkNodes(row.rowDatas, bk.tree.getRowKeyChildren(row.rowKey).length, nodes);
				} else if (pos === EGridDropPos.before) {
					bk.addBkNodes(bk.tree.getRowKeyParent(row.rowKey), bk.tree.getRowKeyIndex(row.rowKey), nodes);
				} else {
					bk.addBkNodes(bk.tree.getRowKeyParent(row.rowKey), bk.tree.getRowKeyIndex(row.rowKey) + 1, nodes);
				}
			}
		}
	}
} as IGridRowDropMgr;


//#### Actions du Bookmark
function addBookmarkAction(action: Action<IShortDescCtx>, accel?: string) {
	REG.reg.addToList("actions:wspApp:bookmarks", action.getId(), 1, action);
	if (accel) REG.reg.addToList("accelkeys:wspApp:bookmarks", accel, 1, action);
}

addBookmarkAction(new BkCreateFolder(), "n-accel");
addBookmarkAction(new BkRenameFolder(), "F2");

addBookmarkAction(new BkCopy(), "c-accel");
addBookmarkAction(new BkCut(), "x-accel");
addBookmarkAction(new BkPasteBefore());
addBookmarkAction(new BkPasteInOrBefore(), "v-accel");
addBookmarkAction(new BkPasteAfter());

addBookmarkAction(new BkDel(), "Delete");
